import React from 'react';

import { mergeClassNameStrings } from '@consumer-frontend/nc-utils';
import { Container, ContainerPropsT } from '@consumer-frontend/shared-ui';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/card.scss';

export type NcContainerPropsT = Omit<ContainerPropsT, 'hasBoxShadow' | 'rounded'> & {
  noBoxShadow?: boolean;
  unrounded?: boolean;
};
export type NcCardT = React.FC<NcContainerPropsT>;

/**
 * NcCard component
 *
 * This is for the rounded cards with drop shadow and white background used across the dashboard.
 */
export const NcCard: NcCardT = ({
  children,
  className,
  noBoxShadow,
  unrounded,
  ...props
}) => {
  return (
    <Container
      className={mergeClassNameStrings(className, 'nc-card')}
      hasBoxShadow={!noBoxShadow}
      rounded={!unrounded}
      {...props}
    >
      {children}
    </Container>
  );
};
